var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.71 10.71C16.32 10.32 15.69 10.32 15.3 10.71L11.71 14.3C11.32 14.69 11.32 15.32 11.71 15.71L15.3 19.3C15.4868 19.4873 15.7405 19.5925 16.005 19.5925C16.2695 19.5925 16.5232 19.4873 16.71 19.3C17.1 18.91 17.1 18.28 16.71 17.89L14.83 16L23.5 16C24.05 16 24.5 15.55 24.5 15C24.5 14.45 24.05 14 23.5 14L14.83 14L16.71 12.12C17.1 11.73 17.09 11.09 16.71 10.71ZM8.5 24L22.5 24C23.61 24 24.5 23.1 24.5 22L24.5 19C24.5 18.45 24.05 18 23.5 18C22.95 18 22.5 18.45 22.5 19L22.5 21C22.5 21.55 22.05 22 21.5 22L9.5 22C8.95 22 8.5 21.55 8.5 21L8.5 9C8.5 8.45 8.95 8 9.5 8L21.5 8C22.05 8 22.5 8.45 22.5 9L22.5 11C22.5 11.55 22.95 12 23.5 12C24.05 12 24.5 11.55 24.5 11L24.5 8C24.5 6.9 23.6 6 22.5 6L8.5 6C7.4 6 6.5 6.9 6.5 8L6.5 22C6.5 23.1 7.4 24 8.5 24Z",
    fill: "#B20000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.f6c5c810e6ee70bbc646754e7cb67413.svg";
export { ForwardRef as ReactComponent };